import { format, parseISO } from 'date-fns';

/**
 * Compact relative-aware date formatter — same behaviour as the legacy
 * Vue lib/format.ts (today → time only; this year → day+time; older → date).
 */
export function formatDateTime(date: string | Date): string {
    if (typeof date === 'string') {
        date = parseISO(date);
    }
    const now = new Date();
    if (format(date, 'dd.MM.yyyy') === format(now, 'dd.MM.yyyy')) {
        return format(date, 'HH:mm');
    }
    if (format(date, 'yyyy') === format(now, 'yyyy')) {
        return format(date, 'dd.MM HH:mm');
    }
    return format(date, 'dd.MM.yyyy');
}
